import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResultsComponent } from './components/results/results.component';

// https://sites.google.com/despegar.com/s-transfers/urls
const routes: Routes = [
  { 
    path: 'transfers/search/:travelType/:originType/:originCode/:destinationType/:destinationCode/:fromDate/:fromTime/:distribution', 
    component: ResultsComponent,
  },
  { 
    path: 'transfers/search/:travelType/:originType/:originCode/:destinationType/:destinationCode/:fromDate/:fromTime/:toDate/:toTime/:distribution',
    component: ResultsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
}) 
export class AppRoutingModule { }
